<template>
  <div class="tw:w-full">
    <p class="tw:mb-6">{{ $t('subscription_cancel_subtext') }}</p>
    <AccommodationCard :currentAccommodation="currentAccommodation" :hasActiveOffer="hasActiveOffer" />
    <ComparisonCard />
    <BookMeetingCard v-if="currentAccommodation" :accommodationId="currentAccommodation.accommodationId" />
  </div>
</template>
<script setup>
import { onUnmounted, onMounted, nextTick, computed } from 'vue'
import { useStore } from 'vuex'

import { useAccommodationsByOrgId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'
import AccommodationCard from './AccommodationCard.vue'
import ComparisonCard from './ComparisonCard.vue'
import BookMeetingCard from './BookMeetingCard.vue'
import { useActiveOffer } from '@/components/hotelOffers/queries'

const props = defineProps({
  accommodationId: Number,
  type: String,
})
const store = useStore()

const selectedOrganisationId = computed(() => store.state?.session?.selectedOrganisation?.id)
const { accommodationsData } = useAccommodationsByOrgId(selectedOrganisationId)
const { hasActiveOffer } = useActiveOffer(props.accommodationId)
const currentAccommodation = computed(
  () => accommodationsData.value.find(item => item.accommodationId === props.accommodationId) || {}
)

const onBookingLinkClick = event => {
  let from = (event.target || event.srcElement).closest('a')
  if (from?.href.includes('outlook.office365.com')) {
    appAnalytics.track(appAnalytics.events.SP_BOOK_APPOINTMENT, {
      accommodationId: props.accommodationId,
    })
  }
}
onMounted(() => {
  nextTick(() => {
    window.addEventListener('click', onBookingLinkClick)
  })
})

onUnmounted(() => {
  window.removeEventListener('click', onBookingLinkClick)
})
</script>
<style scoped>
p :deep(a) {
  text-decoration: underline;
}
</style>
